import { Lock, LockOpen, Person } from '@mui/icons-material'
import { Alert, AlertTitle, Box, CircularProgress, Container, Grid, InputAdornment, Typography } from '@mui/material'
import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { Button, Input } from '../../controls'
import { useForm } from '../../hooks'
import { Form } from '../../layouts'
import { httpClient } from '../../utils'

const defaultValues = {
    username:'',
    password:'',
}


const SignInForm = () => {

    const navigate = useNavigate();
    
    const { 
        values,
        setValues,
        errors,
        setErrors,
        handleValueChange,
        resetForm
    } = useForm(defaultValues);
    
    const httpOptions = { 
        headers : {
            'Content-Type': 'application/json',
        }
    };

    const onInputChange = (e) => handleValueChange(e);

    const mutation = useMutation(formData => {
        return httpClient.post('user/login', formData, httpOptions);
    }, {
        onSuccess: () => {
            navigate('/admin/dashboard');
        },
        onError: (error) => {
            resetForm();
        }
    });

    const formIsValid = () => {
        setErrors({
            username: values.username ? '' : 'This field is required',
            password: values.password ? '' : 'This field is required',
        })

        return (values.username !== '' && values.password !== '');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formIsValid()) {
            mutation.mutate(values);
        }
    }

    if (mutation.status === 'idle' || mutation.status === 'error') return (
        <Form onSubmit={handleSubmit} >
            <Grid textAlign={'center'} container >
                <Grid item xs={12} marginY={{xs:1, md:2}} md={6}>
                    <Input
                        label={'Username'}
                        name={'username'}
                        value={values.username}
                        type={'text'}
                        error={errors.username}
                        InputProps={{
                            endAdornment: <InputAdornment position='start'><Person/></InputAdornment>
                        }}
                        onChange={onInputChange}
                    />
                </Grid>
                <Grid item xs={12} marginY={{xs:1, md:2}} md={6}>
                    <Input
                        label={'Password'}
                        name={'password'}
                        type={'password'}
                        error={errors.password}
                        value={values.password}
                        InputProps={{
                            endAdornment: <InputAdornment position='start'><Lock/></InputAdornment>
                        }}
                        onChange={onInputChange}
                    />
                    {
                        mutation.status === 'error' 
                            ? (<Alert style={{margin:'16px auto' ,width:'85%'}} severity="error">
                            {
                                mutation.error.response.status == 401
                                    ? 'Password is Incorrect'
                                    : mutation.error.response.status == 404 
                                ? 'Username is Incorrect'
                                : 'Something went wrong, please try again later!'
                            }
                            </Alert>) : ''
                    }
                    <Box marginY={2} marginRight={2} textAlign="right" >
                        <Button 
                            size="midium"
                            startIcon={<LockOpen />}
                            type="submit"
                        >Sign In</Button>
                    </Box>
                </Grid>
            </Grid>
        </Form>
    )

    if ( mutation.status == 'loading' ) {
        return (<Grid xs={12} sm={12} md={12} item >
            <Box marginX={'auto'} sx={{ display: 'flex', justifyContent:'center', alignItems:'center', height:"17rem" }}>
                <CircularProgress />
            </Box>
        </Grid>)
    }

}

const SignIn = () => {
    return (
        <Container maxWidth={'md'} >
            <Typography 
                variant='h3'
                align='center'
                gutterBottom
                marginTop={5} >
                Garson
            </Typography>
            <SignInForm />
        </Container>
    )
}

export default SignIn